import React from 'react';
import { Box, Skeleton } from '@mui/material';
import { layout } from '../../themes/smartinventoryTheme';

// The real header/toolbar render immediately (DataTableCard renders them
// unconditionally); this is only the grey row body. Six rows regardless of
// page size, per COMPONENTS.md — never a spinner.
const SkeletonTable = ({ rows = 6, columns = [2.6, 1, 0.7, 0.7], hasThumb = true }) => (
  <Box>
    {Array.from({ length: rows }).map((_, rowIndex) => (
      <Box
        key={rowIndex}
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 2,
          px: 3,
          py: 1.25,
          borderBottom: '1px solid',
          borderColor: 'divider',
        }}
      >
        {hasThumb && <Skeleton variant="rounded" width={layout.rowThumbSize} height={layout.rowThumbSize} sx={{ flexShrink: 0 }} />}
        {columns.map((flex, colIndex) => (
          <Skeleton key={colIndex} variant="rounded" height={12} sx={{ flex }} />
        ))}
      </Box>
    ))}
  </Box>
);

export default SkeletonTable;
